export default {
  updated: 'Zaktualizowano',
  updateError: 'Błąd! Aktualizacja nie powiodła się',
  stored: 'Dodano',
  storeError: 'Błąd! Nie udało się dodać rekordu',
  suspended: 'Zawieszono',
  suspendError: 'Błąd! nie udało się zawiesić rekordu',
  restored: 'Przywrócono',
  restoreError: 'Błąd! Nie udało się przywrócić rekordu',
  deleted: 'Usunięto',
  deleteError: 'Błąd! Nie udało się usunąć rekordu',
  added: 'Dodano',
  addError: 'Błąd! Nie udało się dodać elementu',
  removed: 'Usunięto',
  removeError: 'Błąd! Nie udało się usunąć elementu',
  confirm: 'Czy na pewno chcesz to zrobić?',
}
